import {
    SwitchProps as MuiSwitchProps,
    createStyles,
    lighten,
    makeStyles,
    Switch as MuiSwitch,
} from '@material-ui/core';
import React from 'react';

const useSwitchStyle = makeStyles(theme =>
    createStyles({
        checked: {},
        disabled: {
            '&$checked': {
                '& + $track': {
                    backgroundColor: `${lighten(theme.palette.primary.main, 0.5)} !important`,
                    borderColor: `${lighten(theme.palette.primary.main, 0.5)} !important`,
                },
            },
        },
        root: {
            '& input[type=radio], input[type=checkbox]': {
                margin: 0,
            },
            display: 'flex',
            height: 20,
            padding: 0,
            width: 32,
        },
        switchBase: {
            '&$checked': {
                '& + $track': {
                    backgroundColor: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                    opacity: 1,
                },
                color: theme.palette.common.white,
                transform: 'translateX(12px)',
            },
            color: theme.palette.common.white,
            padding: 2,
        },
        thumb: {
            boxShadow: 'none',
            height: 16,
            width: 16,
        },
        track: {
            backgroundColor: theme.palette.grey[400],
            border: `1px solid ${theme.palette.grey[400]}`,
            borderRadius: 20 / 2,
            opacity: 1,
        },
    }),
);

export type SwitchProps = MuiSwitchProps;

export function Switch(props: SwitchProps): JSX.Element {
    const classes = useSwitchStyle();
    return <MuiSwitch classes={classes} {...props} />;
}
Switch.displayName = 'Switch';
